const navigation = {
	init() {
		this.toggleMobileMenu();
		this.toggleSubMenu();
		this.toggleMobileSubmenu();
	},

	toggleMobileMenu: () => {
		const root = document.documentElement;
		const navigation = document.querySelector( '.rlt-navigation' );
		const navigationMobile = navigation.querySelector( '.rlt-navigation-mobile' );
		const searchInput = navigation.querySelector( '.rlt-search-input' );
		const toggleMobileMenuBtn = document.querySelectorAll(
			'.js-rlt-navigation-btn-more, .rlt-navigation-btn-search'
		);
		const closeMobileMenuBtn = navigationMobile.querySelector(
			'.js-rlt-navigation-mobile-close-btn'
		);
		const backdrop = document.querySelector(
			'.js-rlt-navigation-mobile-backdrop'
		);

		const closeMobileMenu = () => {
			navigationMobile.classList.remove( 'show' );
			root.classList.remove( 'rlt-hide-scrollbar' );
		};

		const handleKeyDown = ( event ) => {
			if ( event.key === 'Escape' ) {
				closeMobileMenu();
			}
		};

		if (
			navigation &&
			navigationMobile &&
			toggleMobileMenuBtn &&
			closeMobileMenuBtn &&
			backdrop &&
			searchInput
		) {
			toggleMobileMenuBtn.forEach( ( toggle ) => {
				toggle.addEventListener( 'click', ( e ) => {
					e.preventDefault();
					navigationMobile.classList.toggle( 'show' );
					root.classList.toggle( 'rlt-hide-scrollbar' );
					if ( navigationMobile.classList.contains( 'show' ) ) {
						setTimeout( () => {
							searchInput.focus();
						}, 450 );
					}
				} );
			} );

			closeMobileMenuBtn.addEventListener( 'click', ( e ) => {
				e.preventDefault();
				closeMobileMenu();
			} );

			backdrop.addEventListener( 'click', () => {
				closeMobileMenu();
			} );

			document.addEventListener( 'keydown', handleKeyDown );
		}
	},

	toggleSubMenu: () => {
		const isNonTouchDevice =
			! ( 'ontouchstart' in window ) || ! navigator.maxTouchPoints;

		if ( ! isNonTouchDevice ) {
			return;
		}

		const menuItems = document.querySelectorAll(
			'.rlt-navigation-menu .menu-item-has-children'
		);

		menuItems.forEach( ( item ) => {
			const link = item.querySelector( '.rlt-navigation-menu-link' );
			const submenu = item.querySelector( '.sub-menu' );

			if ( ! link || ! submenu ) {
				return;
			}

			// Show submenu on click.
			link.addEventListener( 'pointerup', ( e ) => {
				if ( e.pointerType === 'touch' ) {
					e.preventDefault();
					submenu.classList.toggle( 'show' );
				}
			} );

			// Show submenu on hover.
			item.addEventListener( 'mouseenter', () => {
				submenu.classList.add( 'show' );
			} );

			// Hide submenu when the cursor leaves.
			item.addEventListener( 'mouseleave', () => {
				submenu.classList.remove( 'show' );
			} );

			// Show submenu when any element inside item receives focus.
			item.addEventListener( 'focusin', () => {
				submenu.classList.add( 'show' );
			} );

			// Hide submenu when focus leaves item and all its child elements.
			item.addEventListener( 'focusout', () => {
				// Small delay to avoid conflict with focus transition.
				setTimeout( () => {
					const active = item.ownerDocument.activeElement;
					if ( ! item.contains( active ) ) {
						submenu.classList.remove( 'show' );
					}
				}, 10 );
			} );

			// Close on Escape.
			document.addEventListener( 'keydown', ( e ) => {
				if ( e.key === 'Escape' ) {
					submenu.classList.remove( 'show' );
					link.blur();
				}
			} );
		} );
	},

	toggleMobileSubmenu: () => {
		const submenuLinkItems = document.querySelectorAll(
			'.rlt-navigation-mobile .menu-item-has-children > a'
		);

		submenuLinkItems.forEach( ( link ) => {
			const toggleHTML = `
				<button
					type="button"
					class="rlt-submenu-toggle"
					aria-expanded="false"
					aria-label="Open submenu"
					tabindex="0"
				>
					<svg
						width="16"
						height="16"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
						aria-hidden="true"
					>
						<path
							d="M6 9L11.2929 14.2929C11.6262 14.6262 11.7929 14.7929 12 14.7929C12.2071 14.7929 12.3738 14.6262 12.7071 14.2929L18 9"
							stroke="currentColor"
							stroke-width="1.5"
							stroke-linecap="round"
							stroke-linejoin="round"
						></path>
					</svg>
				</button>
			`;

			link.insertAdjacentHTML( 'afterend', toggleHTML );
		} );

		const submenuItems = document.querySelectorAll(
			'.rlt-navigation-mobile .menu-item-has-children > .sub-menu'
		);

		submenuItems.forEach( ( submenu ) => {
			const links = submenu.querySelectorAll( 'a' );
			links.forEach( ( link ) => {
				link.setAttribute( 'tabindex', '-1' );
			} );
		} );

		const toggles = document.querySelectorAll( '.rlt-submenu-toggle' );
		toggles.forEach( ( toggle ) => {
			toggle.addEventListener( 'click', ( event ) => {
				event.preventDefault();

				const menuItem = toggle.closest( '.menu-item-has-children' );
				const submenu = menuItem.querySelector( '.sub-menu' );

				menuItem.classList.toggle( 'active' );

				if ( submenu ) {
					const submenuLinks = submenu.querySelectorAll( 'a' );
					submenuLinks.forEach( ( link ) => {
						link.setAttribute(
							'tabindex',
							menuItem.classList.contains( 'active' ) ? '0' : '-1'
						);
					} );
				}
			} );

			toggle.addEventListener( 'keydown', ( e ) => {
				if ( e.code === 'Space' || e.key === ' ' ) {
					e.preventDefault();
					toggle.click();
				}
			} );
		} );
	},
};

navigation.init();
